import Footer from '../components/Footer'

// hideLetter: 登録やSettingsの途中のページでは、フッターで購読を勧めない
export default function AppLayout({ children, hideLetter = false }) {
  return (
    <>
      <main className="container mx-auto mt-4 mb-16 px-4 flex md:mt-8 md:mb-24 md:px-5">
        {children}
      </main>
      <Footer hideLetter={hideLetter} />
    </>
  )
}
